import React from 'react';

export const CurrentLocationMarker: React.FC = () => {
    return (
        // -translate-x/y-1/2 puts the dot ON the coordinate, not below-right of it.
        <div className="relative flex items-center justify-center w-6 h-6 -translate-x-1/2 -translate-y-1/2">
            <div
                className="absolute w-full h-full rounded-full opacity-30 animate-ping motion-reduce:animate-none"
                style={{ backgroundColor: 'var(--color-steel)' }}
            ></div>
            <div
                className="relative w-4 h-4 border-2 border-white rounded-full shadow-md"
                style={{ backgroundColor: 'var(--color-steel)' }}
            ></div>
        </div>
    );
};
